import React, {FC, FormEvent, useState} from "react";
import {
    useCreateNoteByOrderIdMutation,
    useGetOrderNoteListQuery,
    useUpdateNoteVisibilityMutation
} from "../productsApi";
import {useDispatch} from "react-redux";
import {handleRTKQuery} from "../../../helpers/utils/RtkQueryUtils";
import {tgxApi} from "../../../app/tgxApi";
import {skipToken} from "@reduxjs/toolkit/query";
import CommonNotesForm from "../../../components/common/CommonNotesGrid/CommonNotesGrid";
import {useParams} from "react-router-dom";
import NotesUpdateOrAddModal from "../../../components/common/CommonNotesGrid/NoteAddOrUpdateModal";
import {useUtilDataQuery} from "../../profile/profileApi";

interface props {
    productId?: string
}

const OrderNotes: FC<props> = ({productId}) => {

    const {orderId} = useParams();
    const {
        data: orderNotes
    } = useGetOrderNoteListQuery(orderId || skipToken);

    const [showAddModal, setShowshowAddModal] = useState(false);
    const dispatch = useDispatch();
    const [updateNoteVisibility, {isLoading}] = useUpdateNoteVisibilityMutation()
    const [noteBody, setNoteBody] = useState<string>("");
    const [createNotesApi, createNotesApiResp] = useCreateNoteByOrderIdMutation();
    const {data: utilData} = useUtilDataQuery("");
    const [external, setExternal] = useState<boolean>(false);


    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const obj = {
            noteBody: noteBody,
            external: external,
            noteType: utilData.customerLevel === "CUSTOMER" ? "CUSTOMER" : "ORDER"

        }
        await handleRTKQuery(
            async () => {
                return await createNotesApi({"productId": orderId, requestBody: obj}).unwrap();
            },
            () => {
                dispatch(tgxApi.util.invalidateTags(["orderNoteList"]))
            }
        );

        setNoteBody("")
    }


    const handleVisiblity = async (noteId: string) => {
        if (noteId) {
            return await updateNoteVisibility({productId: orderId, id: noteId}).unwrap();
        }
    };

    return (
        <>

            <CommonNotesForm
                data={orderNotes}
                title="Notes"
                type="Order"
                count={orderNotes?.length || 0}
                setShow={setShowshowAddModal}
                handleDelete={handleVisiblity}
                isLoading={isLoading}
                addPermissions={"ONOT-C"}
            />

            {showAddModal &&
                <NotesUpdateOrAddModal title={"Add Notes"}
                                       show={showAddModal}
                                       setShow={setShowshowAddModal}
                                       relationalId={productId}
                                       type={"Order"}
                                       length={orderNotes && orderNotes.length + 1}
                                       btnName="Add" setNoteBody={setNoteBody} noteBody={noteBody}
                                       handleSubmit={handleSubmit} isLoading={createNotesApiResp.isLoading}
                                       isExternalInternal={true}
                                       external={external}
                                       setExternal={setExternal}
                />
            }
        </>
    )
}

export default OrderNotes;